import React from "react";

export default function OpenedCaseCard({ openedCase }) {
  if (!openedCase) return null;

  return (
    <>
      <div
        style={{
          fontSize: "22px",
          fontWeight: "800",
          color: "#166534",
          marginBottom: "12px",
        }}
      >
        👁 Opened Case #{openedCase.id}
      </div>

      <div><strong>Account:</strong> {openedCase.account_name}</div>
      <div><strong>Bureau:</strong> {openedCase.bureau}</div>
      <div><strong>Priority:</strong> {openedCase.priority}</div>
      <div><strong>Violation:</strong> {openedCase.primary_violation}</div>
      <div><strong>Letter:</strong> {openedCase.recommended_letter}</div>
      <div><strong>Status:</strong> {openedCase.case_status}</div>
    </>
  );
}
